import { render } from "./CustomerAddEdit.vue?vue&type=template&id=57794a7c&scoped=true"
import script from "./CustomerAddEdit.vue?vue&type=script&lang=js"
export * from "./CustomerAddEdit.vue?vue&type=script&lang=js"

import "./CustomerAddEdit.vue?vue&type=style&index=0&id=57794a7c&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57794a7c"]])

export default __exports__